import React from "react";

const CardPrestamosBiblio = ({titulo, inventario, devolucion, complemento}) => (

    <div>
        <h3 className="h5 mb-2">{titulo}</h3>
        <p className="text-muted mb-2">
            Ejemplar: <b>{complemento}</b> &middot; Inventario: <b>{inventario}</b>
        </p>
        <span className="esen-chip esen-chip--info">
            <i className="fa fa-calendar" aria-hidden="true"></i>
            Devolución: {devolucion}
        </span>
    </div>
);

export default CardPrestamosBiblio;
